exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-72233bcd] {\r\n  background: #fff;\n}\n.pagination-container.hidden[data-v-72233bcd] {\r\n  display: none;\n}\n[data-v-72233bcd] .el-pagination .el-select .el-input{\r\n  margin-top: -0.04rem;\n}\r\n", ""]);

// exports
